import styled from "styled-components";

const ModalCustomAvisos = styled.div`
  display: ${(props) => (props.isOpen ? "block" : "none")};
  
  width: 92%
  position: inherit;
  left: 50%;
  top: calc(50% + -55px);
  transform: translate(-50%, -50%);
  background: white;
  align-items: center;
  overflow:scroll;
`;

export default ModalCustomAvisos;